<cass-core-toolbar></cass-core-toolbar>
<div class="page-container">

	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="title-card">
				<h1>{{ "USERS.ACTIVATE_ACCOUNT.PAGE_TITLE" | translate }}</h1>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class="branding--section-card">
		<mat-card-content>
			<div class="confirmation-mesage">
				<ng-container *ngIf="registeringUserEmail">
					{{ "USERS.ACTIVATE_ACCOUNT.CONFIRMATION_MESSAGE_FOR_REGISTER_FLOW" | translate: { email: registeringUserEmail } }}
				</ng-container>
				<ng-container *ngIf="!registeringUserEmail">
					{{ "USERS.ACTIVATE_ACCOUNT.CONFIRMATION_MESSAGE_FOR_ASSISTED_FLOW" | translate }}
				</ng-container>
			</div>
			<div class="activation-form-container">
				<form [formGroup]="activateUserForm" class="activate-user-form" (ngSubmit)="activateAction()">
					<mat-form-field *ngIf="!registeringUserEmail">
						<mat-label>{{ "USERS.ACTIVATE_ACCOUNT.FORM_LABEL_EMAIL" | translate }}</mat-label>
						<input matInput formControlName="email" id="email" name="email" autocomplete="username">
						<mat-error cassErrorForFormControlName="email"></mat-error>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "USERS.ACTIVATE_ACCOUNT.FORM_LABEL_ACTIVATION_CODE" | translate }}</mat-label>
						<input matInput formControlName="verificationCode" id="verification-code" name="verification-code" autocomplete="one-time-code">
						<mat-error cassErrorForFormControlName="verificationCode"></mat-error>
					</mat-form-field>

					<mat-form-field *ngIf="!registeringUserEmail">
						<mat-label>{{ "USERS.COMMON.FORM_LABEL_ENTER_NEW_PASSWORD" | translate }}</mat-label>
						<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" formControlName="newPassword" id="new-password" name="new-password" autocomplete="new-password">
						<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
							<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
						<mat-error cassErrorForFormControlName="newPassword"></mat-error>
					</mat-form-field>

					<mat-form-field *ngIf="!registeringUserEmail">
						<mat-label>{{ "USERS.COMMON.FORM_LABEL_CONFIRM_NEW_PASSWORD" | translate }}</mat-label>
						<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" formControlName="confirmPassword" id="confirm-password" name="confirm-password" autocomplete="new-password">
						<button mat-icon-button matSuffix type="button" (click)="isPasswordShown = !isPasswordShown">
							<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
						</button>
						<mat-error cassErrorForFormControlName="confirmPassword"></mat-error>
					</mat-form-field>
				</form>
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class='footer branding--action-card button-container'>
		<mat-card-content>
			<button mat-raised-button color='primary' (click)="activateAction()">{{ "USERS.ACTIVATE_ACCOUNT.ACTION_ACTIVATE" | translate }}</button>
		</mat-card-content>
	</mat-card>

</div>
